module.exports = __webpack_public_path__ + "static/img/wealth_level_64.28e172a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_64.png
// module id = ul4M
// module chunks = 0